import { ListItem, styled } from '@mui/material';
import { Button } from '@elements';
import { colors, pxToRem } from '@themes';
var StyledListItem = styled(ListItem)(function (_ref) {
  var theme = _ref.theme;
  return {
    display: 'flex'
  };
});
var StyledButton = styled(Button, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'active';
  }
})(function (_ref2) {
  var theme = _ref2.theme,
      active = _ref2.active;
  return {
    backgroundColor: active ? colors.gin : 'transparent',
    padding: "".concat(pxToRem(10), " ").concat(pxToRem(12)),
    borderRadius: pxToRem(16),
    color: active ? theme.colors.funGreen : theme.colors.mineShaft,
    fontWeight: active ? '500' : '400',
    justifyContent: 'flex-start',
    textAlign: 'left',
    textTransform: 'none',
    width: '100%',
    '& .MuiButton-startIcon': {
      color: active ? theme.colors.funGreen : theme.colors.raven
    },
    '&:hover': {
      backgroundColor: colors.gin
    }
  };
});
export { StyledButton, StyledListItem };